<template>
  <el-scrollbar max-height="600px">
    <el-icon><Memo /></el-icon>全部章节
    <div class="demo-collapse">
    <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item :title="chapter.chapterName" :name="chapter.chapterId" v-for="chapter in chapters" :key="chapter.chapterId">

        <div v-for="data in chapter.data" :key="data.dataId">
          <div :class="data.hasRead != '100' ? 'dataBorder' : 'dataBorderHasRead'">
            <img src="@/assets/img/card/video.png" class="dataImg" v-if="data.dataType == 0">
            <img src="@/assets/img/card/ppt.png" class="dataImg" v-if="data.dataType == 1">
            <img src="@/assets/img/card/docx.png" class="dataImg" v-if="data.dataType == 2">
            <img src="@/assets/img/card/other.png" class="dataImg" v-if="data.dataType == 3">
            <span class="dataFont">{{ data.dataName }}</span>
            <el-progress class="dataRead" :width="45" type="circle" :percentage="100" status="success" v-if="data.hasRead == 100"/>
            <el-progress class="dataRead" :width="45" type="circle" :percentage="33" color="#f56c6c" v-if="data.hasRead == 33" />
            <el-progress class="dataRead" :width="45" type="circle"  :percentage="67" v-if="data.hasRead == 67" />
            <el-progress class="dataRead" :width="45" type="circle" :percentage="0" color="#6f7ad3" v-if="data.hasRead == null"/>
            
            <router-link :to="'/video/' + courseId + '/' + data.dataLink" target="_blank">
              <el-button type="warning" icon="VideoPlay" class="dataBtn" v-if="data.dataType == 0" circle>
              </el-button>
            </router-link>
            <el-button type="success" icon="Download" class="dataBtn" v-if="data.dataType != 0" circle @click="download(data.dataLink, data.dataId)"></el-button>
          </div>
          
        </div>
        </el-collapse-item>
    </el-collapse>
    </div>
</el-scrollbar>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import $ from 'jquery';

const Route = useRoute(); //获取到值
const courseId = ref("");
let chapters = ref([]);



onMounted(() => {
  courseId.value = Route.params.courseId;
  pullChapterList();
});


// 拉取章节列表
const pullChapterList = () => {
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/chapter/getChapterList",
        data: {
            courseId: courseId.value,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
          console.log(resp.data);
        if (resp.code == "200") {
            chapters.value = resp.data;
        } else {
            ElMessage({
            type: "error",
            message: "拉取章节失败",
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "拉取章节失败",
        });
        },
    });
}

const download = (link, id) => {
 

  const token = localStorage.getItem("token");
  $.ajax({
        url: "http://124.222.105.205:5000/api/data/addStudyRecord",
        data: {
            dataId: id,
            courseId: courseId.value,
            progress: "100"
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
          console.log(resp.data);
        if (resp.code == "200") {
          pullChapterList();
          setTimeout(() => {
            downloadFile(link);  
          }, 200);
          
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "学习记录添加失败",
        });
        },
    });
    
}

const downloadFile = (link) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

</script>

<style>


.dataImg {
  width: 70px;
  height: 60px;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.dataFont {
  font-size: medium;
  font-weight:bold ;
  padding-left:50px;
}

.dataBorder {
  margin: 5px;
  background-color: rgba(255, 255, 255, 0.821);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
}

.dataBorder:hover{
  margin: 5px;
  background-color: rgba(225, 225, 225, 0.389);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
  transition: 200ms;
}

.dataBorderHasRead {
  position: relative;
  margin: 5px;
  background-color: rgba(193, 255, 191, 0.356);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
}

.dataBorderHasRead:hover{
  position: relative;
  margin: 5px;
  background-color: rgba(162, 241, 159, 0.541);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
}

.dataRead {
  float: right;
  margin: 5px;
  font-size: 10px;
}


.dataBtn {
  float: right;
  margin-right: 5px;
  margin-top: 10px;
  margin-bottom: 5px;
}


.display {
  color: rgba(240, 248, 255, 0);
}
</style>